import React from 'react';
import PropTypes from 'prop-types';

import colors from '../../../../constants/colors';
import IconButton from '../../../IconButton';

import styles from './EditButton.module.scss';

const EditButton = ({ onClick }) => {
  return (
    <div className={styles.buttonWrapper}>
      <IconButton
        className={styles.button}
        icon="edit"
        onClick={onClick}
        iconProps={{ color: colors.primary }}
      />
    </div>
  );
};

EditButton.propTypes = {
  onClick: PropTypes.func,
};

export default EditButton;
